// extracted by mini-css-extract-plugin
export default {"features-main-box":"Features_features-main-box__uhhQL"};